import type { ReactNode } from 'react';
import { ImageOff } from 'lucide-react';
import { cn } from '@/lib/utils';
import { labelCls } from './styles';

export function Field({
  label,
  hint,
  children,
}: {
  label: string;
  hint?: ReactNode;
  children: ReactNode;
}) {
  return (
    <label className="block">
      <span className={labelCls}>{label}</span>
      {children}
      {hint && <span className="mt-1 block text-xs text-text-secondary">{hint}</span>}
    </label>
  );
}

/** Cabeçalho de passo: título curto + uma frase dizendo o que fazer. */
export function StepHeader({ title, description }: { title: string; description: string }) {
  return (
    <div className="mb-5">
      <h2 className="text-lg font-semibold text-text-title">{title}</h2>
      <p className="mt-1 text-sm text-text-secondary">{description}</p>
    </div>
  );
}

/** Linha "rótulo ... valor" de extrato de preço. */
export function Row({
  label,
  value,
  strong,
  muted,
}: {
  label: ReactNode;
  value: string;
  strong?: boolean;
  muted?: boolean;
}) {
  return (
    <div className="flex items-baseline justify-between gap-4 py-1.5 text-sm">
      <span className="text-text-secondary">{label}</span>
      <span
        className={cn(
          'shrink-0',
          strong
            ? 'font-semibold text-text-title'
            : muted
              ? 'text-text-secondary'
              : 'text-text-body'
        )}
      >
        {value}
      </span>
    </div>
  );
}

/** Miniatura do produto; cai num ícone quando não há imagem. */
export function Thumb({ url, className }: { url?: string; className: string }) {
  return url ? (
    <img
      src={url}
      alt=""
      className={cn(className, 'shrink-0 rounded-md border border-border object-cover')}
    />
  ) : (
    <span
      className={cn(
        className,
        'flex shrink-0 items-center justify-center rounded-md border border-border bg-bg-main text-text-secondary'
      )}
    >
      <ImageOff size={14} />
    </span>
  );
}
